import MrpaSubject from '@/components/services/common/MrpaSubject.vue';
import MrpaSelect from '@/components/services/common/MrpaSelect.vue';
import StepProxy from './StepProxy/index.vue';
import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const steps: unknown[] = [MrpaSubject, StepProxy];

if (isMrpaEnable(StatementType.ROD)) {
  steps.unshift(MrpaSelect);
}

export default steps;
